module.exports = __webpack_public_path__ + "static/media/screen_tiles_3.16610a9a.svg";